var map = {
	"./achievements.svg": "6cc0",
	"./creatures.svg": "b6de",
	"./exchange.svg": "e908",
	"./fashion.svg": "35d0",
	"./fencing.svg": "782d",
	"./fossils.svg": "da77",
	"./gyroids.svg": "e63e",
	"./hhp.svg": "3c9d",
	"./housewares.svg": "6a89",
	"./licenses.svg": "d38a",
	"./music.svg": "ba85",
	"./nookpoints.svg": "34bc",
	"./other.svg": "4dd5",
	"./photos.svg": "8574",
	"./plants.svg": "9c04",
	"./posters.svg": "18f1",
	"./reactions.svg": "71bd",
	"./recipes.svg": "addc",
	"./season.svg": "c3fc",
	"./special.svg": "cf44",
	"./tools.svg": "3ed8",
	"./versions.svg": "0baa",
	"./walletc.svg": "2e80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86f1";